import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { FailedAlternatives } from './components/FailedAlternatives';
import { SolutionIntro } from './components/SolutionIntro';
import { AboutJose } from './components/AboutJose';
import { Services } from './components/Services';
import { BeforeAfter } from './components/BeforeAfter';
import { Gallery } from './components/Gallery';
import { LifeBack } from './components/LifeBack';
import { ServiceAreas } from './components/ServiceAreas';
import { GoogleReviews } from './components/GoogleReviews';
import { Guarantee } from './components/Guarantee';
import { WhoFor } from './components/WhoFor';
import { FinalCTA } from './components/FinalCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { FloatingActions } from './components/FloatingActions';
export function App() {
  return <div className="min-h-screen bg-[#F9F9F9] font-sans selection:bg-[#C8102E] selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainSection data-id="element-4" />
        <FailedAlternatives data-id="element-5" />
        <SolutionIntro data-id="element-6" />
        <AboutJose data-id="element-7" />
        <Services data-id="element-8" />
        <BeforeAfter data-id="element-9" />
        <Gallery data-id="element-10" />
        <LifeBack data-id="element-11" />
        <ServiceAreas data-id="element-12" />
        <GoogleReviews data-id="element-13" />
        <Guarantee data-id="element-14" />
        <WhoFor data-id="element-15" />
        <FinalCTA data-id="element-16" />
        <FAQ data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
      <FloatingActions data-id="element-19" />
    </div>;
}